import $ from 'jquery';
import '../Libraries/magnific-popup';

if ($('html').attr('lang') === 'de') {
    $.extend(true, $.magnificPopup.defaults, {
        overflowY: 'scroll',
        tLoading: 'Lädt...',
        tClose: 'Schließen (ESC)',
        gallery: {
            tPrev: 'Vorheriges Bild',
            tNext: 'Nächstes Bild',
            tCounter: '%curr% von %total%'
        }
    });
}
